<label *ngIf="file" class="file-label">
  <span class="text-ellipsis w-md" [tooltip]="file.filename">{{file.filename}}</span>
  <span class="file-actions">
    <i *ngIf="isViewAttachmentsActive && isSupportedFileType(file.filename)"
      class="fa fa-light fa-eye pointer p-l-sm"
       [tooltip]="'TOOLTIPS.view' | translate"
       (click)="viewFile($event)">
    </i>
    <i class="fa fa-light fa-download pointer p-x-sm"
       [tooltip]="'EMPLOYEE_MANAGE.download' | translate"
       *ngIf="!downloading"
       (click)="downloadFile()">
    </i>
    <i *ngIf="downloading" class="fa fa-light fa-spinner fa-spin p-x-sm"></i>
    <i class="fa fa-light fa-trash-alt pointer"
       [tooltip]="'EMPLOYEE_MANAGE.remove' | translate"
       *ngIf="!readOnly"
       (click)="deleteFile()">
    </i>
  </span>
</label>
<label *ngIf="!file"
       [ngClass]="{
             'file-field': true,
             'over': isOver,
             'input-disabled': readOnly
            }"
       (dragover)="onDragOver()"
       (dragleave)="onDragLeave()"
       (drop)="onDrop()">
  <i class="fa fa-light fa-upload"></i>
  {{ readOnly ? ('FORM_GENERATOR.no_file_choosen' | translate) :
  ('FORM_GENERATOR.choose_or_drop' | translate) }}
  <input type="file"
         [attr.test-id]="descriptor.zoneID"
         accept="
image/vnd.djvu,
application/msword,
application/vnd.openxmlformats-officedocument.wordprocessingml.document,
application/gzip,
image/jpeg,
audio/mpeg,
audio/mpeg,
application/pdf,
image/png,
text/plain,
text/xml,
application/vnd.ms-excel,
application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/zip
"
         *ngIf="!readOnly"
         (change)="uploadFile($event)"/>
</label>
<i *ngIf="loading" class="fa fa-light fa-spinner fa-spin"></i>
<ul class="msg-list" *ngIf="savedMsg">
  <li *ngIf="savedMsg">{{'FORMS.file_saved' | translate}}<i class="fa fa-light fa-check" aria-hidden="true"></i></li>
</ul>
<ul class="error-list" [attr.data-hidden]="!maxFileSize">
  <li>{{'FORMS.VALIDATORS.file_size_5MB' | translate}}</li>
</ul>

<gp-view-document-side-panel
  *ngIf="showViewDocumentPanelInFileField"
  (close)="onCloseSidePanel()"
  [currentFileName]="currentFileName"
  [error]="previewError"
  [noSupportedFormat]="noSupportedFormat"
  [loading]="loadingPreview"
  [preview]="reportDefinitionPreview"
></gp-view-document-side-panel>

